
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1NJu1", function(module, exports) {
const $bff07b8bbb17f66c$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $bff07b8bbb17f66c$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $bff07b8bbb17f66c$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $bff07b8bbb17f66c$export$71ff7382870ef1b0;

});

parcelRegister("ll379", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $jTNdj = parcelRequire("jTNdj");


var $cozmU = parcelRequire("cozmU");


var $1NVwf = parcelRequire("1NVwf");


var $3WFdt = parcelRequire("3WFdt");

const $0443f5c700dc203b$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $3WFdt.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                name: (0, $jTNdj.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $0443f5c700dc203b$export$b35129264a401b3c = /*#__PURE__*/ (0, $cozmU.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $cXtTj.default).checkGate('post_office_update_ufov2_placements');
    /**
   * If feature gate is not enabled, then we just return the children without the
   * UFO segments attached.
   */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $0443f5c700dc203b$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $0443f5c700dc203b$export$b35129264a401b3c;

});

parcelRegister("jTNdj", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $65DSU = parcelRequire("65DSU");

const $8f5948bf59d85fb8$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $b8pma.default),
    UFOSegment: (0, $65DSU.default)
};
module.exports["UFOv2"] = $8f5948bf59d85fb8$export$c91b09caa8ecbab1;

});

parcelRegister("1NVwf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $2808315b9dcd7678$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $2808315b9dcd7678$export$21b400a8c8ebc91a;

});

parcelRegister("3WFdt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7da53318f1fd530c$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(initialData !== undefined);
    const onMount = (0, $cozmU.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $cozmU.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
module.exports["usePerformanceTracking"] = $7da53318f1fd530c$export$317d52099614f316;

});

parcelRegister("qzjr4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $lTlGN = parcelRequire("lTlGN");


var $im2FK = parcelRequire("im2FK");


var $6NRmI = parcelRequire("6NRmI");


var $li4w8 = parcelRequire("li4w8");


var $5SfHd = parcelRequire("5SfHd");


var $9Nqm6 = parcelRequire("9Nqm6");


var $5SRox = parcelRequire("5SRox");


var $ll379 = parcelRequire("ll379");

/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
const $b95d67109e64283f$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 */ const $b95d67109e64283f$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    const isPostOfficeSubscriptionsFeatureGateEnabled = (0, $cXtTj.default).checkGate($b95d67109e64283f$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    if (isPostOfficeSubscriptionsFeatureGateEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Nqm6.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
const $b95d67109e64283f$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $li4w8.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SfHd.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SRox.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $im2FK.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($b95d67109e64283f$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6NRmI.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lTlGN.RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $b95d67109e64283f$export$2b6596bcb1383a71;

});

parcelRegister("lTlGN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $9Nqm6 = parcelRequire("9Nqm6");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $0688fdc237844f49$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $9Nqm6.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $cozmU.useEffect)(()=>{
        if ($0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["RenderTrackerProvider"] = $0688fdc237844f49$export$2d84fd9af6c9e378;

});

parcelRegister("9Nqm6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $ffaea1b52a58fd24$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscription: undefined
});
const $ffaea1b52a58fd24$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ffaea1b52a58fd24$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $ffaea1b52a58fd24$export$1129f1fe63b2d7ab = ()=>{
    return (0, $cozmU.useContext)($ffaea1b52a58fd24$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $ffaea1b52a58fd24$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $ffaea1b52a58fd24$export$1129f1fe63b2d7ab;

});

parcelRegister("im2FK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $f1G3w = parcelRequire("f1G3w");

const $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "4e9ad917f6e2c5d567a95b22fd1bd4eeecd189cc",
            b: "24314396",
            t: undefined
        }
    }
};
const $15ac6ff16ee48c24$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData,
        children: children
    });
};
module.exports["StableAnaltyicsProvider"] = $15ac6ff16ee48c24$export$5a66cdc9893b43e;

});

parcelRegister("li4w8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $bGVJw = parcelRequire("bGVJw");


var $1RMKR = parcelRequire("1RMKR");


var $1NJu1 = parcelRequire("1NJu1");

const $52edb35a97f45deb$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $1RMKR.useStableObject)({
        ...(0, $1NJu1.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bGVJw.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
module.exports["StableContextProvider"] = $52edb35a97f45deb$export$d4982c0a28b18f63;

});

parcelRegister("5SfHd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $4cICV = parcelRequire("4cICV");

const $9ea687c3ab35e390$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $1RMKR.useStableObject)(placement);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cICV.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
module.exports["StablePlacementProvider"] = $9ea687c3ab35e390$export$e9fd288527498af6;

});

parcelRegister("5SRox", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $5h1mk = parcelRequire("5h1mk");


var $1RMKR = parcelRequire("1RMKR");


var $2LW9e = parcelRequire("2LW9e");

const $2e96bdbc145ab642$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $2LW9e.useLocationHref)();
    const stableRoute = (0, $1RMKR.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5h1mk.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
module.exports["StableRouteProvider"] = $2e96bdbc145ab642$export$ce13d00e696dfc96;

});

parcelRegister("2LW9e", function(module, exports) {
const $0e2c91a22a84681f$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $0e2c91a22a84681f$export$49fc3f3d8c7f99 = ()=>{
    return $0e2c91a22a84681f$var$isLocationAvailable() ? globalThis.location.href : undefined;
};
module.exports["useLocationHref"] = $0e2c91a22a84681f$export$49fc3f3d8c7f99;

});

parcelRegister("8BCsI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $852mP = parcelRequire("852mP");


var $9TNXZ = parcelRequire("9TNXZ");


var $9EOlJ = parcelRequire("9EOlJ");

const $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: {
                        name: error.name,
                        message: error.message,
                        stack: error.stack
                    },
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $8aG6j.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withErrorBoundary"] = $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7;

});

parcelRegister("b4B1V", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $38aadf7fa80db7e7$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $cozmU.createContext)($38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue);
const $38aadf7fa80db7e7$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $cozmU.useRef)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($38aadf7fa80db7e7$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $38aadf7fa80db7e7$export$bb426ba114b64992 = ()=>(0, $cozmU.useContext)($38aadf7fa80db7e7$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $38aadf7fa80db7e7$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $38aadf7fa80db7e7$export$bb426ba114b64992;

});

parcelRegister("d4rpM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");

const $2edd5268d1298569$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $2edd5268d1298569$export$8e6fb7035018b3e4;

});

parcelRegister("gKIF0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $k50GG = parcelRequire("k50GG");

const $721b9c50d6cef8f5$export$dac988aa97dc7b79 = ({ children: children, waitForTrigger: waitForTrigger })=>{
    if (!waitForTrigger) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k50GG.TriggeredMessageValidator), {
        waitForTrigger: waitForTrigger,
        children: children
    });
};
module.exports["MaybeTriggeredMessageValidator"] = $721b9c50d6cef8f5$export$dac988aa97dc7b79;

});

parcelRegister("k50GG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $7edc18d494c18e25$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $cozmU.useState)('pending');
    (0, $4mjUI.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            setValidated('allowed');
            return;
        }
        // Ref not set after template had a chance to run.
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: isHidden ? $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
};
module.exports["TriggeredMessageValidator"] = $7edc18d494c18e25$export$c8b5f992b8a1b38b;

});

parcelRegister("4mjUI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * `useLayoutEffect` warns during SSR ("Warning: useLayoutEffect does nothing on the server").
 * Fall back to `useEffect` on the server so utilities in this package are safe to render in SSR
 * contexts. In the browser the synchronous commit-time semantics of `useLayoutEffect` are preserved.
 *
 * Consumers import this as `useLayoutEffect` so the call site reads identically to React's hook.
 *
 * See: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */ const $c7f27652ce5a6cdc$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
module.exports["useLayoutEffect"] = $c7f27652ce5a6cdc$export$e5c5a5f917a5871c;

});

parcelRegister("bP5wt", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $wnnKE = parcelRequire("wnnKE");


var $8hKSa = parcelRequire("8hKSa");


var $7NHN3 = parcelRequire("7NHN3");

/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $5ae52cbfb074d546$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $cozmU.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        messageInstanceViewed(additionalMetadataFromFrontend);
        onShow?.();
    // Intentional empty deps: this effect must fire exactly once after the first commit.
    // The values captured here are the ones the caller passed at mount, which is the desired
    // "as of when the message was shown" semantic — if a caller subsequently passes a new
    // onShow or metadata, we should NOT fire again. Using non-empty deps would also cause
    // this effect to re-register on every render whenever a caller passes an unmemoized
    // `additionalMetadataFromFrontend={{ ... }}` literal, even though the body is a no-op
    // after first run. Strict-Mode double-invocation is still handled by hasShownRef.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
const $5ae52cbfb074d546$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const waitForTriggerCalledRef = (0, $cozmU.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $cozmU.useCallback)(({ isTriggerActive: isTriggerActive, messageContent: messageContent, onMessageShown: onMessageShown, additionalMetadataFromFrontend: additionalMetadataFromFrontend, onTeardown: onTeardown })=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        const messageContentWithOptionalTeardown = onTeardown !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hKSa.UnmountCleanup), {
            onCleanup: onTeardown,
            children: messageContent
        }) : messageContent;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $wnnKE.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ae52cbfb074d546$var$OnChoreographerApproved, {
                onShow: onMessageShown,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContentWithOptionalTeardown
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent,
        inAppNarrowExposureExperiment
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
module.exports["useWaitForTrigger"] = $5ae52cbfb074d546$export$b5884e72fa051e28;

});

parcelRegister("wnnKE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $5ydwr = parcelRequire("5ydwr");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $6NRmI = parcelRequire("6NRmI");

const $4a16561cf48266ce$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldClaim = (0, $5ydwr.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        shouldClaim: shouldClaim
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $4a16561cf48266ce$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($4a16561cf48266ce$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $4a16561cf48266ce$export$8db7ba034addcd65;

});

parcelRegister("8hKSa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

const $522a2bdcd9585e84$export$ea970fe2c565070a = ({ onCleanup: onCleanup, children: children })=>{
    const onCleanupRef = (0, $cozmU.useRef)(onCleanup);
    (0, $4mjUI.useLayoutEffect)(()=>{
        onCleanupRef.current = onCleanup;
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onCleanupRef.current?.();
        };
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["UnmountCleanup"] = $522a2bdcd9585e84$export$ea970fe2c565070a;

});

parcelRegister("44R0O", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $j5DVd = parcelRequire("j5DVd");

const $18ac7c17ff477189$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    return isManual ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["MaybeManualMessageViewedEvent"] = $18ac7c17ff477189$export$9915b88f81e90e6e;

});

parcelRegister("j5DVd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $7NHN3 = parcelRequire("7NHN3");


var $baFbJ = parcelRequire("baFbJ");


var $cozmU = parcelRequire("cozmU");


var $lixOz = parcelRequire("lixOz");


var $b4B1V = parcelRequire("b4B1V");


var $1NVwf = parcelRequire("1NVwf");

const $08ec3000a15d9da6$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
const $08ec3000a15d9da6$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $cozmU.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $08ec3000a15d9da6$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $cozmU.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $lixOz.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $8aG6j.jsx)($08ec3000a15d9da6$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
module.exports["ManualMessageViewedEvent"] = $08ec3000a15d9da6$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $08ec3000a15d9da6$export$14fe1fc3395b6e3f;

});

parcelRegister("baFbJ", function(module, exports) {

var $di43e = parcelRequire("di43e");


var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $4cICV = parcelRequire("4cICV");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $5Rfgj = parcelRequire("5Rfgj");

parcelRequire("aByw7");
var $dEG1b = parcelRequire("dEG1b");


var $lOnm2 = parcelRequire("lOnm2");

const $858a4870c67919f0$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $cozmU.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $lOnm2.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $lOnm2.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $lOnm2.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $cozmU.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};
module.exports["useMessageEvent"] = $858a4870c67919f0$export$3cbbf1e81e2ecb39;

});

parcelRegister("5Rfgj", function(module, exports) {
class $4253c717b3565d29$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $4253c717b3565d29$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}
module.exports["MessageLifecycleContextError"] = $4253c717b3565d29$export$12bb62b204112f55;
module.exports["MessageLifecycleClientError"] = $4253c717b3565d29$export$44f397e2afeb89e0;

});

parcelRegister("aByw7", function(module, exports) {
$parcel$export(module.exports, "MessageEventClient", () => (parcelRequire("dEG1b")).MessageEventClient);
/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */ 
var $dEG1b = parcelRequire("dEG1b");


});

parcelRegister("lOnm2", function(module, exports) {
var $984aeda379ad7f1a$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
module.exports["InAppMessageEventType"] = $984aeda379ad7f1a$export$b31ffc6f7c85f1b;

});

parcelRegister("lixOz", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $f8158248d0f47600$export$6215040b989f9b0f, (v) => $f8158248d0f47600$export$6215040b989f9b0f = v);
var $f8158248d0f47600$export$1e511d4a378977f5;
var $f8158248d0f47600$export$6215040b989f9b0f;
var $f8158248d0f47600$export$436b63fa4855237f;
var $f8158248d0f47600$export$2e2bcd8739ae039;
var $f8158248d0f47600$export$95cef81be5ddcfd4;
"use strict";
$f8158248d0f47600$export$1e511d4a378977f5 = true;
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$export$95cef81be5ddcfd4 = void 0;

var $f8158248d0f47600$var$_handleViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("3Tfn6")));
$f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$var$_handleViewport.default;

var $f8158248d0f47600$var$_useInViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("byriw")));
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$var$_useInViewport.default;
function $f8158248d0f47600$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $f8158248d0f47600$var$customProps = $f8158248d0f47600$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $f8158248d0f47600$var$_default = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$var$_handleViewport.default;

});

parcelRegister("3Tfn6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $2d526ea1e19243c2$export$1e511d4a378977f5, (v) => $2d526ea1e19243c2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2d526ea1e19243c2$export$2e2bcd8739ae039, (v) => $2d526ea1e19243c2$export$2e2bcd8739ae039 = v);
var $2d526ea1e19243c2$export$1e511d4a378977f5;
var $2d526ea1e19243c2$export$2e2bcd8739ae039;
"use strict";
$2d526ea1e19243c2$export$1e511d4a378977f5 = true;
$2d526ea1e19243c2$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $2d526ea1e19243c2$var$_hoistNonReactStatics = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("aH9xZ")));

var $2d526ea1e19243c2$var$_useInViewport = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("byriw")));

var $3dWch = parcelRequire("3dWch");


var $8aG6j = parcelRequire("8aG6j");

var $2d526ea1e19243c2$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $2d526ea1e19243c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2d526ea1e19243c2$var$_extends() {
    return $2d526ea1e19243c2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d526ea1e19243c2$var$_extends.apply(null, arguments);
}
function $2d526ea1e19243c2$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(TargetComponent, $2d526ea1e19243c2$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $3dWch.noop, onLeaveViewport: onLeaveViewport = $3dWch.noop } = _ref, restProps = $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(_ref, $2d526ea1e19243c2$var$_excluded);
        var node = (0, $cozmU.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $2d526ea1e19243c2$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $2d526ea1e19243c2$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ForwardedRefComponent, $2d526ea1e19243c2$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $2d526ea1e19243c2$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $2d526ea1e19243c2$var$_default = $2d526ea1e19243c2$export$2e2bcd8739ae039 = $2d526ea1e19243c2$var$handleViewport;

});

parcelRegister("byriw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $86980b6f9121fe40$export$1e511d4a378977f5, (v) => $86980b6f9121fe40$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $86980b6f9121fe40$export$2e2bcd8739ae039, (v) => $86980b6f9121fe40$export$2e2bcd8739ae039 = v);
var $86980b6f9121fe40$export$1e511d4a378977f5;
var $86980b6f9121fe40$export$2e2bcd8739ae039;
"use strict";
$86980b6f9121fe40$export$1e511d4a378977f5 = true;
$86980b6f9121fe40$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $3dWch = parcelRequire("3dWch");

var $86980b6f9121fe40$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $86980b6f9121fe40$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    if (props === void 0) props = $3dWch.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $cozmU.useState)();
    var observer = (0, $cozmU.useRef)();
    var inViewportRef = (0, $cozmU.useRef)(false);
    var intersected = (0, $cozmU.useRef)(false);
    var enterCountRef = (0, $cozmU.useRef)(0);
    var leaveCountRef = (0, $cozmU.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $cozmU.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $cozmU.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $cozmU.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $86980b6f9121fe40$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $86980b6f9121fe40$var$_default = $86980b6f9121fe40$export$2e2bcd8739ae039 = $86980b6f9121fe40$var$useInViewport;

});

parcelRegister("3dWch", function(module, exports) {
$parcel$export(module.exports, "noop", () => $258fbab87dea3908$export$8793edee2d425525, (v) => $258fbab87dea3908$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $258fbab87dea3908$export$9c21a3269931e1e6, (v) => $258fbab87dea3908$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $258fbab87dea3908$export$ba43bf67f3d48107, (v) => $258fbab87dea3908$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $258fbab87dea3908$export$f84bd70098573c5c, (v) => $258fbab87dea3908$export$f84bd70098573c5c = v);
var $258fbab87dea3908$export$1e511d4a378977f5;
var $258fbab87dea3908$export$8793edee2d425525;
var $258fbab87dea3908$export$9c21a3269931e1e6;
var $258fbab87dea3908$export$ba43bf67f3d48107;
var $258fbab87dea3908$export$f84bd70098573c5c;
"use strict";
$258fbab87dea3908$export$1e511d4a378977f5 = true;
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$export$9c21a3269931e1e6 = $258fbab87dea3908$export$ba43bf67f3d48107 = $258fbab87dea3908$export$f84bd70098573c5c = void 0;
var $258fbab87dea3908$var$defaultOptions = $258fbab87dea3908$export$ba43bf67f3d48107 = {};
var $258fbab87dea3908$var$defaultConfig = $258fbab87dea3908$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $258fbab87dea3908$var$noop = ()=>{};
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$var$noop;
var $258fbab87dea3908$var$defaultProps = $258fbab87dea3908$export$9c21a3269931e1e6 = {
    onEnterViewport: $258fbab87dea3908$var$noop,
    onLeaveViewport: $258fbab87dea3908$var$noop
};

});

parcelRegister("jS1GQ", function(module, exports) {
const $6bdcc106a64db8f9$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
module.exports["isClientTriggeredMessage"] = $6bdcc106a64db8f9$export$21c420c0c257c346;

});

parcelRegister("1dHYE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

const $c24c1359cebc9ade$export$738797901aa9197a = ({ ChoreographerWrapper: ChoreographerWrapper, enabled: enabled, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, children: children })=>{
    if (!enabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(ChoreographerWrapper, {
        messageId: messageId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
        children: children
    });
};
module.exports["MaybeChoreographerWrapper"] = $c24c1359cebc9ade$export$738797901aa9197a;

});

parcelRegister("aeEJA", function(module, exports) {

var $9TNXZ = parcelRequire("9TNXZ");


var $j4yZr = parcelRequire("j4yZr");


var $cozmU = parcelRequire("cozmU");


var $fRJAi = parcelRequire("fRJAi");

class $d65c3221c86fee02$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $d65c3221c86fee02$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $cozmU.useState)((0, $fRJAi.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $cozmU.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $fRJAi.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $fRJAi.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $d65c3221c86fee02$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $fRJAi.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $d65c3221c86fee02$export$8c5224d3af2f3c8b;
module.exports["useData"] = $d65c3221c86fee02$export$c1cf1cf4c5d51937;

});

parcelRegister("fRJAi", function(module, exports) {
const $b02ec9b1100b044c$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $b02ec9b1100b044c$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($b02ec9b1100b044c$export$18a0019e5439b209(res));
};
const $b02ec9b1100b044c$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $b02ec9b1100b044c$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $b02ec9b1100b044c$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });
module.exports["assertResponseIsOk"] = $b02ec9b1100b044c$export$b3732c8ff6f9c463;
module.exports["toLoading"] = $b02ec9b1100b044c$export$f9a5bd0ffba29ffc;
module.exports["toError"] = $b02ec9b1100b044c$export$cc3b967c039ed3e7;
module.exports["toData"] = $b02ec9b1100b044c$export$24a6b176bdc41ce5;

});


//# sourceMappingURL=ShareAndRestrictDialog.bc4990ad.js.map
